import { module } from 'stereomodularjs';
import modularLoad from '../utils/load';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        window.scrollTo(0, 0);

        this.load = new modularLoad({
            enterDelay: 600
        });

        
        // On link click
        this.load.on('loading', (transition, oldContainer) => {
            classRemove(document.querySelector('html'), 'is-first-load')
            classRemove(document.querySelectorAll('.has-nav-open'), 'has-nav-open')
            classRemove(document.querySelectorAll('.has-search-open'), 'has-search-open')
            classRemove(document.querySelectorAll('.has-overlay-open'), 'has-overlay-open')
            classRemove(document.querySelectorAll('.has-anchor'), 'has-anchor')
            classAdd(document.querySelector('html'), 'is-changing-page')
            this.currentClass= 't-' + document.querySelector('.js-scroll').getAttribute('data-namespace');
            
        });

        // On new container enter
        this.load.on('loaded', (transition, oldContainer, newContainer) => {
            classRemove(document.querySelector('body'), this.currentClass)
            this.call('destroy', oldContainer, 'app');
        });

        // On old container exit
        this.load.on('ready', (transition, newContainer) => {
            this.call('update', newContainer, 'app');
            classAdd(document.querySelector('html'), 'is-loaded')
            classRemove(document.querySelector('html'), 'is-changing-page')
            classAdd(document.querySelector('html'), 'dom-is-loaded')
            classAdd(document.querySelector('body'), 't-' + document.querySelector('.js-scroll').getAttribute('data-namespace'))
            // console.log('ADD CLASS CURRENT PAGE : t-' + document.querySelector('.js-scroll').getAttribute('data-namespace'));

            var htmlElement = document.documentElement;
            var newOffset;

            // Déterminez la largeur de la fenêtre
            var windowWidth = window.innerWidth;

            // Réglez la valeur en fonction de la largeur de la fenêtre
            if (windowWidth < 768) { // Si la largeur est inférieure à 768 pixels (mobile)
                newOffset = '-100';
            } else if (windowWidth < 1024) { // Si la largeur est inférieure à 1024 pixels (tablettes)
                newOffset = '-120';
            } else {
                newOffset = '-200'; // Par défaut pour les écrans plus larges
            }

            // Mettez à jour l'attribut data-scroll-default-offset
            if (htmlElement.hasAttribute('data-scroll-default-offset')) {
                htmlElement.setAttribute('data-scroll-default-offset', newOffset);
            }
        });
    }

    goTo(obj) {
        this.load.goTo(obj.url, obj.transition);
    }

    destroy() {
        this.modularLoad.destroy();
    }
}
